import React from 'react';
import type { SelectChangeEvent } from '@mui/material';
import { Box, useTheme } from '@mui/material';
import SelectBase from '../../../../../../primeX-underwriter/components/footer/SelectBase';
import SimpleTooltip from '../../../../../../../../components/SimpleTooltip';
import {
  REFERRAL_STRATEGY_OPTIONS,
  ReferralStrategyForEdit,
} from '../../types';
import { REFERRAL_STRATEGY_DROPDOWN_STYLES } from './styles/referralStrategyDropdown.styles';
import {
  getReferralStrategyLabel,
  MIXED_VALUE,
} from './utils/referralStrategyDropdown.utils';

type SingleReferralStrategyDropdownProps = {
  value: ReferralStrategyForEdit | null | undefined;
  onChange: (strategy: ReferralStrategyForEdit) => void;
};

function SingleReferralStrategyDropdown({
  value,
  onChange,
}: SingleReferralStrategyDropdownProps) {
  const theme = useTheme();
  const selectValue = value || ReferralStrategyForEdit.NONE;

  const handleChange = (
    e: SelectChangeEvent<ReferralStrategyForEdit | typeof MIXED_VALUE>
  ) => {
    const newStrategy = e.target.value;

    if (newStrategy === MIXED_VALUE) {
      return;
    }

    onChange(newStrategy as ReferralStrategyForEdit);
  };

  const renderValue = (selected: unknown) => {
    const value = selected as ReferralStrategyForEdit | typeof MIXED_VALUE;
    const label = getReferralStrategyLabel(value);
    return (
      <Box
        sx={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </Box>
    );
  };

  return (
    <Box display="flex" alignItems="center" gap="0.5rem">
      <SimpleTooltip title="Referral Strategy" placement="top">
        <SelectBase
          options={REFERRAL_STRATEGY_OPTIONS}
          name="single"
          value={selectValue}
          onChange={handleChange}
          sx={REFERRAL_STRATEGY_DROPDOWN_STYLES.select(theme)}
          MenuProps={{
            PaperProps: {
              sx: REFERRAL_STRATEGY_DROPDOWN_STYLES.menu,
            },
          }}
          renderValue={renderValue}
        />
      </SimpleTooltip>
    </Box>
  );
}

export default SingleReferralStrategyDropdown;
